import {t} from 'i18next';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ImageComponent from '../../components/inputs/ImageComponent';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import YesNoDialog from '../../components/YesNoDialog';
import AchievementService from '../../services/AchievementService';
import ChallengeService from '../../services/ChallengeService';
import FileUploadService from '../../services/FileUploadService';
import SettingService from '../../services/SettingService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import AchievementCreateRequest from './AchievementCreateRequest';
import AchievementDetailsResponse from './AchievementDetailsResponse';
import ChallengeCreateRequest from './ChallengeCreateRequest';
import {default as ChallengeDetailsResponse} from './ChallengeDetailsResponse';
import SimpleReactValidator from '../../components/validator';
import StringUtils from '../../utils/StringUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import PublishToCompaniesDialog from '../../components/PublishToCompaniesDialog';
import PublishedToCompaniesList from '../../components/PublishedToCompaniesList';

class ActionContainer extends BaseDetailsContainer {
    constructor(props) {
        props.type === 'ACHIEVEMENT' ? super(props, new AchievementService()) : super(props, new ChallengeService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            viewMode: props.viewMode,
            //challengetype: false,
            type: props.type,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: {
                translations: [],
                challengeType: props.type,
                activityType: null,
            },
            challengeTypes: [],
            activityTypes: [],
            measureTypes: [],
            parameters: [],
            showPublishDialog: false,
            showPublishToCompaniesDialog: false,
            showConfirmRemoveDialog: false,
            localizedActions: [],
            noLocalizedActions: [],
            transportOptions: [],
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.renderLanguages = this.renderLanguages.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.handlePublishToCompanies = this.handlePublishToCompanies.bind(this);
        this.publish = this.publish.bind(this);
        this.publishToCompanies = this.publishToCompanies.bind(this);
        this.componentRef = React.createRef();
        this.uploadPhotoHandler = this.uploadPhotoHandler.bind(this);
        this.resetAfterChallengeTypeChange = this.resetAfterChallengeTypeChange.bind(this);
        this.hideGoalValue = this.hideGoalValue.bind(this);
        this.showTransportUnit = this.showTransportUnit.bind(this);
        this.validator = new SimpleReactValidator({}, this.translate);
        this.hideDistanceMeasureUnitValue = this.hideDistanceMeasureUnitValue.bind(this);
        this.validator.addCustomRule('image', 'Zdjęcie jest wymagane', () => {
            return StringUtils.isBlank(this.state.element.photoTemporaryFileUrl);
        });
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                element:
                    this.props.type === 'ACHIEVEMENT'
                        ? AchievementDetailsResponse.copy(this.state.element, data)
                        : ChallengeDetailsResponse.copy(this.state.element, data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
        if (data.status === 'ACTIVE' || data.status === 'REMOVED') {
            this.setState({
                viewMode: 'VIEW',
            });
        }
    }

    setElement() {
        const {viewMode} = this.props;
        const {type} = this.props;
        const {elementId, locale} = this.state;
        // const {challengeAchievementType} = this.props
        this.beforeUpdateElement(viewMode, elementId, locale, type);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.type === 'ACHIEVEMENT'
                            ? this.props.viewMode === 'NEW'
                                ? new AchievementCreateRequest(supportedLocales)
                                : new AchievementDetailsResponse(supportedLocales)
                            : this.props.viewMode === 'NEW'
                            ? new ChallengeCreateRequest(supportedLocales)
                            : new ChallengeDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });

        this.service
            .getLocalizedEnumListForChallengesOrAchievements('ChallengeType', this.props.type)
            .then((challengeTypes) =>
                this.setState({
                    challengeTypes,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('challenge.challengesError'));
            });

            this.enumService
            .getLocalizedEnumList('ActivityType')
            .then((activityTypes) =>
                this.setState({
                    activityTypes,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('challenge.activityTypeError'));
            });

        this.enumService
            .getLocalizedEnumList('ChallengeMeasureUnit')
            .then((measureTypes) =>
                this.setState({
                    measureTypes,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('challenge.measureUnitsError'));
            });

        this.service
            .getActionsReferences('LOCALIZATION', this.props.elementId)
            .then((localizedActions) =>
                this.setState({
                    localizedActions: localizedActions.list,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.errorMessage'));
            });
        this.service
            .getActionsReferences('NO_LOCALIZATION', this.props.elementId)
            .then((noLocalizedActions) =>
                this.setState({
                    noLocalizedActions: noLocalizedActions.list,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.errorMessage'));
            });
        this.service
            .getTransportReferences(this.props.elementId)
            .then((transportOptions) =>
                this.setState({
                    transportOptions: transportOptions.list,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.errorMessage'));
            });
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW' && this.state.element.status?.value === 'DRAFT',
            },
            {
                label: t('global.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state.element.status?.value === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: 'Publikuj do wielu',
                onClick: this.handlePublishToCompanies,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered:
                    this.props.type !== 'ACHIEVEMENT' &&
                    this.state.element.status?.value === 'DRAFT' &&
                    viewMode === 'VIEW' &&
                    this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR'),
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLanguages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .remove(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage(
                        'success',
                        '',
                        this.props.type === 'ACHIEVEMENT' ? t('achievement.successRemove') : t('challenge.successRemove')
                    );
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(this.props.type === 'ACHIEVEMENT' ? t('achievement.removeError') : t('challenge.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        this.setState({
            showPublishDialog: true,
        });
    }

    handlePublishToCompanies() {
        this.setState({
            showPublishToCompaniesDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();

            this.blockUi();
            if (this._isMounted) {
                this.service
                    .publish(this.state.elementId)
                    .then(() => {
                        const {backUrl} = this.props;
                        this.blockUi();
                        this.persistMessage('success', '', t('challenge.publishSuccess'));
                        // window.location.href = backUrl;
                        this.props.history.push(backUrl);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({showPublishDialog: false});
                        this.unblockUi();
                    });
            }
        } else {
            this.setState({showPublishDialog: false});
        }
    }

    publishToCompanies(externalIds) {
        this.scrollToTop();
        this.blockUi();
        this.service
            .publishToCompanies(this.state.elementId, {externalIds})
            .then(() => {
                const {backUrl} = this.props;
                this.persistMessage('success', '', 'Wyzwanie zostalo opublikowane do wybranych firm.');
                this.props.history.push(backUrl);
            })
            .catch((err) => {
                this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                this.setState({showPublishToCompaniesDialog: false});
                this.unblockUi();
            });
    }

    getAddSucces() {
        return this.props.type === 'ACHIEVEMENT' ? t('achievement.createSuccess') : t('challenge.createSuccess');
    }

    getUpdateSucces() {
        return this.props.type === 'ACHIEVEMENT' ? t('achievement.updateSuccess') : t('challenge.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        element.challengeType = element.challengeType?.enumValue;
        element.activityType = element.activityType?.enumValue;
        element.measureUnit = element.measureUnit?.enumValue;
        element.type = this.props.type;
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
        element.translations = Object.assign({}, element.translations);
        const request = this.prepareElementBeforeRequest(JSON.parse(JSON.stringify(element)));

        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    hideGoalValue(type) {
        return [
            'REGISTER',
            'HIGHER_RANK',
            'JOIN_GROUP',
            'SCAN_FIRST_QR',
            'BUY_APP',
            'UPDATE_PERSONAL_INFO',
            'FIRST_QUIZ',
            'FIRST_RANKINGS',
            'FIRST_STATISTICS',
            'FIRST_GROUPS',
            'FIRST_ACHIEVEMENTS',
            'FIRST_VERIFICATION',
            'FIRST_QUIZ',
            'FIRST_ACTIONS',
            'FIRST_NEWS',
            'FIRST_VOUCHERS',
            'FIRST_CHALLENGES',
        ].find((t) => t === (type && type?.enumValue));
    }

    showTransportUnit(type, measureUnit) {
        return 'TRANSPORT' === type?.enumValue && 'DISTANCE' === measureUnit?.enumValue;
    }

    hideDistanceMeasureUnitValue(type) {
        return ['QUIZ', 'QR_CODE', 'VERIFICATION', 'VERIFICATION_LOCATION', 'ACTION', 'ACTION_LOCALIZATION', 'VISIT_APPLICATION', 'ACTIVITY'].find(
            (t) => t === (type && type?.enumValue)
        );
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={this.props.type === 'ACHIEVEMENT' ? t('achievement.publishHeader') : t('challenge.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{this.props.type === 'ACHIEVEMENT' ? t('achievement.publishBody') : t('challenge.publishBody')}</span>
                </YesNoDialog>
                <PublishToCompaniesDialog
                    visible={this.state.showPublishToCompaniesDialog}
                    header='Publikuj wyzwanie do wielu firm'
                    body='Wybierz firmy, do ktorych chcesz opublikowac to wyzwanie.'
                    onHide={() => {
                        this.setState({showPublishToCompaniesDialog: false});
                    }}
                    onPublish={this.publishToCompanies}
                />
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={this.props.type === 'ACHIEVEMENT' ? t('achievement.removeTitle') : t('challenge.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{this.props.type === 'ACHIEVEMENT' ? t('achievement.removeBody') : t('challenge.removeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }
    getContainerListName() {
        return 'challenge-list-container';
    }

    breadCrumbItems() {
        return [
            {
                name: this.props.type === 'ACHIEVEMENT' ? t('achievement.listTitle') : t('challenge.listTitle'),
                url: this.props.type === 'ACHIEVEMENT' ? '/achievements-list' : '/challenge-list',
            },
            {name: this.props.type === 'ACHIEVEMENT' ? t('achievement.details') : t('challenge.details'), url: ``},
        ];
    }

    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status?.value === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }

    renderDetails() {
        const {elementId} = this.state;
        const {locale} = this.state;
        return (
            <React.Fragment>
                <div className='row'>
                    <PublishedToCompaniesList
                        companies={this.state.element?.publishedToCompanies}
                        rendered={this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR')}
                    />
                    <div className='col-md-12 col-sm-12'>
                        <InputTextComponent
                            id={`${locale}-title`}
                            name='title'
                            label={t('challenge.title')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[locale]?.title}
                            validator={this.validator}
                            validators='required|max:128'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            stateField={`element.translations[${locale}]`}
                        />

                        <div>
                            <div className=' row p-label'>
                                <label>{this.props.type === 'ACHIEVEMENT' ? t('achievement.photo') : t('challenge.photo')}</label>
                            </div>

                            <ImageComponent
                                reqiredLabel={`Pole ${t('challenge.photo')} jest wymagane.`}
                                key='challenge-photo'
                                srcUrl={`${this.service.getPath()}/attachment/${
                                    this.state.element?.photo?.uuid
                                }?token=${this.authService?.getToken()}`}
                                alt='Action photo'
                                handleRemove={(e) => {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            photo: null,
                                            removePhoto: true,
                                        },
                                    }));
                                }}
                                notValidImageTypeErrorMessage={() => {
                                    this.showErrorMessage(t('image.notValidImageType'));
                                }}
                                errorMessage={this.showErrorMessage}
                                imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                                fileSizeToTranslation={this.state.fileSizeToTranslation}
                                attachment={this.state.element.photo}
                                setFile={this.uploadPhotoHandler}
                                t={t}
                                required={true}
                                validator={this.validator}
                                viewMode={this.viewMode()}
                                fileUploadService={this.fileUploadService}
                            />
                        </div>

                        <InputNumberComponent
                            id='coinsToEarn'
                            name='coinsToEarn'
                            label={t('challenge.coinsToEarn')}
                            colClass='col-md-12'
                            min={0}
                            value={this.state.element.coinsToEarn}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange} //
                            viewMode={this.viewMode()}
                        />
                        {this.props.type !== 'ACHIEVEMENT' ? (
                            <InputCalendarRangeComponent
                                key={'active'}
                                idFrom={'activeFrom'}
                                idTo={'activeTo'}
                                nameTo={'activeTo'}
                                nameFrom={'activeFrom'}
                                label={''}
                                labelFrom={t('challenge.activityRangeFrom')}
                                labelTo={t('challenge.activityRangeTo')}
                                colClass='col-12'
                                from={this.state.element.activeFrom}
                                to={this.state.element.activeTo}
                                validator={[this.validator, this.validatorDraft]}
                                onChange={this.handleChange}
                                viewMode={this.viewMode()}                                
                                showIcon
                                validatorsTo={`required|date|after_or_equal_datetime~${moment(
                                    this.state.element.activeFrom ? this.state.element.activeFrom : new Date()
                                )
                                    .format('DD-MM-YYYY')
                                    .toString()}`}
                                placeholderFrom='dd-mm-rrrr'
                                placeholderTo='dd-mm-rrrr'
                                validateViewMode
                                dateFormatMoment='DD-MM-YYYY'
                                validatorsToType='after_or_equal_datetime'
                            />
                        ) : null}
                    </div>

                    <InputTextEditorComponent
                        colClass='col-xl-12'
                        id='description'
                        name='description'
                        value={this.state.element?.translations[this.state.locale]?.description}
                        key={`description-${this.props.viewMode}`}
                        label={this.props.type !== 'ACHIEVEMENT' ? t('challenge.description') : t('achievement.detailsField')}
                        validator={this.validator}
                        validators='required'
                        rows='5'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        disabled={this.props.viewMode === 'VIEW'}
                        autoResize
                        editorRef={this.editorRef}
                        externalPhotos={true}
                        photos={this.state.element.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel='fileName'
                        photoName='uuid'
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName='photos'
                        stateField={`element.translations[${this.state.locale}]`}
                    />
                    <div className='row'>
                        <InputDropdownComponent
                            id='challengeType'
                            name='challengeType'
                            label={this.props.type !== 'ACHIEVEMENT' ? t('challenge.challengeType') : t('achievement.challengeType')}
                            optionLabel='label'
                            dataKey='enumValue'
                            validator={this.validator}
                            validators='required'
                            value={this.state.element.challengeType}
                            options={this.state.challengeTypes}
                            colClass='col-lg-6 col-md-12 col-sm-12'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            enumMode={true}
                            onAfterStateChange={this.resetAfterChallengeTypeChange}
                        />
                         <InputDropdownComponent
                        id='activityType'
                        name='activityType'
                        label={t('challenge.activityTypechallengeType')}
                        rendered={this.state.element.challengeType != null ? this.state.element.challengeType.enumValue=='ACTIVITY' : false}
                        optionLabel='label'
                        dataKey='enumValue'
                        validator={this.validator}
                        validators='required'
                        value={this.state.element.activityType}
                        options={this.state.activityTypes[`${this.state.locale}`]}
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        enumMode={true}
                       // onAfterStateChange={this.resetAfterChallengeTypeChange}
                    />
                     <InputDropdownComponent
                        id='transport'
                        name='transport'
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        label={t('challenge.transport')}
                        value={this.state.element.transport}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        options={this.state.transportOptions}
                        dataKey='id'
                        optionLabel='title'
                        filter
                        filterBy='title'
                        rendered={this.state.element.challengeType?.enumValue === 'TRANSPORT'}
                        itemTemplate={this.transportTemplate}
                    />
                    </div>

                   
                    <div className='row'>
                    <InputNumberComponent
                        id='goalValue'
                        name='goalValue'
                        label={
                            this.showTransportUnit(this.state.element.challengeType, this.state.element.measureUnit)
                                ? t('challenge.goalValueMeters')
                                : t('challenge.goalValue')
                        }
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        min={0}
                        value={this.state.element.goalValue}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        rendered={!this.hideGoalValue(this.state.element.challengeType)}
                    />

                    <InputDropdownComponent
                        id='measureUnit'
                        name='measureUnit'
                        label={t('challenge.measureUnit')}
                        optionLabel='label'
                        dataKey='enumValue'
                        validator={this.validator}
                        validators='required'
                        value={this.state.element.measureUnit}
                        options={
                            this.hideDistanceMeasureUnitValue(this.state.element.challengeType)
                                ? this.state.measureTypes[`${this.state.locale}`].filter((mt) => mt.enumValue !== 'DISTANCE')
                                : this.state.measureTypes[`${this.state.locale}`]
                        }
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        enumMode={true}
                        rendered={!this.hideGoalValue(this.state.element.challengeType)}
                    />
                    </div>

                    <InputDropdownComponent
                        id='action'
                        name='action'
                        colClass='col-md-12'
                        label={t('challenge.action')}
                        value={this.state.element.action}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        options={this.state.noLocalizedActions}
                        dataKey='id'
                        optionLabel='title'
                        filter
                        filterBy='title'
                        rendered={this.state.element.challengeType?.enumValue === 'ACTION'}
                        itemTemplate={this.actionTemplate}
                    />
                    <InputDropdownComponent
                        id='action'
                        name='action'
                        colClass='col-md-12'
                        label={t('challenge.action')}
                        value={this.state.element.action}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        options={this.state.localizedActions}
                        dataKey='id'
                        optionLabel='title'
                        filter
                        filterBy='title'
                        rendered={this.state.element.challengeType?.enumValue === 'ACTION_LOCALIZATION'}
                        itemTemplate={this.actionTemplate}
                    />
                   
                    <InputCheckboxComponent
                        id='sendPushWhenCompleted'
                        name='sendPushWhenCompleted'
                        labelOnRight
                        label={
                            this.props.type === 'ACHIEVEMENT'
                                ? t('achievement.sendPushWhenCompleted')
                                : t('challenge.sendPushWhenCompleted')
                        }
                        value={this.state.element.sendPushWhenCompleted}
                        validator={this.validator}
                        validators='not_required'
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        disabled={this.viewMode() === 'VIEW'}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                    />
                    {this.props.type === 'CHALLENGE' && (
                        <InputCheckboxComponent
                            id='cyclical'
                            name='cyclical'
                            labelOnRight
                            label={t('challenge.cyclical')}
                            value={this.state.element.cyclical}
                            validator={this.validator}
                            validators='not_required'
                            colClass='col-lg-6 col-md-12 col-sm-12'
                            disabled={this.viewMode() === 'VIEW'}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                        />
                    )}
                    <InputCheckboxComponent
                            id='relatedToCommuteWork'
                            name='relatedToCommuteWork'
                            labelOnRight
                            label={t('challenge.relatedToCommuteWork')}
                            value={this.state.element.relatedToCommuteWork}
                            validator={this.validator}
                            validators='not_required'
                            colClass='col-lg-6 col-md-12 col-sm-12'
                            disabled={this.viewMode() === 'VIEW'}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                    />
                    {!!this.state.element.sendPushWhenCompleted ? (
                        <InputTextComponent
                            id={`${locale}-pushMessage`}
                            name='pushMessage'
                            label={t('achievement.pushMessage')}
                            colClass='col-md-12'
                            value={this.state.element?.translations[locale]?.pushMessage}
                            validator={this.validator}
                            validators='required|max:255'
                            onChange={this.handleChange}
                            viewMode={this.viewMode()}
                            stateField={`element.translations[${locale}]`}
                        />
                    ) : null}
                </div>
            </React.Fragment>
        );
    }
    uploadPhotoHandler(uploadedFile) {
        if(uploadedFile != null){
            this.setState((prevState) => ({
                uploadedFile,
                element: {
                    ...prevState.element,
                    photoTemporaryFileUrl: uploadedFile?.uuid,
                },
            }));
        }
    }
    resetAfterChallengeTypeChange() {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                action: null,
            },
        }));
    }

    actionTemplate(item) {
        return (
            <div>
                <div>
                    {item.title}
                    {`${!!item.removed ? ` (${t('challenge.actionOptionRemoved')})` : ''}`}
                    {`${!!item.expired ? ` (${t('challenge.actionOptionExpired')})` : ''}`}
                </div>
            </div>
        );
    }
    transportTemplate(item) {
        return (
            <div>
                <div>
                    {item.title}
                    {`${!!item.removed ? ` (${t('challenge.transportOptionRemoved')})` : ''}`}
                </div>
            </div>
        );
    }
}

ActionContainer.defaultProps = {
    backUrl: '/challenge-list',
    editUrl: '/challenge/edit',
    detailUrl: '/challenge/details',
    lazy: true,
};

ActionContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ActionContainer));
